import { useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';


const Chatbot = () => {
    const chatBotConfig = useSelector((state: RootState) => state.user.userDetails?.chatbot_config);
    const scriptLoaded = useRef(false);

    const getChatElements = useCallback((): Element[] => {
        if (!chatBotConfig?.tag) return [];
        return Array.from(document.getElementsByTagName(chatBotConfig.tag));
    }, []);

    const updateChatVisibility = useCallback(() => {
        if (!scriptLoaded.current) return;

        const chatElements = getChatElements();
        if (chatElements.length === 0) return;

        chatElements.forEach(element => {
            if (element instanceof HTMLElement) {
                element.style.display = chatBotConfig?.is_enabled ? 'block' : 'none';
            }
        });
    }, [chatBotConfig?.is_enabled, getChatElements]);

    useEffect(() => {
        if (scriptLoaded.current || !chatBotConfig?.is_enabled || !chatBotConfig?.src) return;

        const script = document.createElement('script');
        script.type = 'module';
        script.src = chatBotConfig.src;
        script.async = true;

        script.onload = () => {
            scriptLoaded.current = true;
            const bot = document.createElement(chatBotConfig.tag);
            bot.setAttribute('data-testid', 'mhe-chatbot');
            if (chatBotConfig.platform) {
                bot.setAttribute('platform', chatBotConfig.platform);
            }
            if (chatBotConfig.id) {
                bot.setAttribute('appId', chatBotConfig.id);
                bot.setAttribute('showReferences', "false");
            }
            const chatContainer = document.getElementById('mhe-chat-container');
            if (chatContainer) {
                chatContainer.appendChild(bot);
            } else {
                document.body.appendChild(bot);
            }
        };
        script.onerror = (error) => {
            console.error('Failed to load MheChat script:', error);
        };

        document.head.appendChild(script);

        return () => {
            getChatElements().forEach(element => {
                if (element.parentNode) {
                    element.parentNode.removeChild(element);
                }
            });
        };
    }, [chatBotConfig, getChatElements]);

    useEffect(() => {
        updateChatVisibility();
    }, [updateChatVisibility]);

    return <div id="mhe-chat-container" />;
};

export default Chatbot;
